module.exports = __webpack_public_path__ + "img/353.6e8bc409.jpg";